import React, { useState, useEffect } from "react";

const AudioRecorder = ({ initialBase64 }) => {
  const [recordedChunks, setRecordedChunks] = useState([]);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [blob, setBlob] = useState(null);
  const [isRecording, setIsRecording] = useState(false);

  useEffect(() => {
    if (mediaRecorder) {
      mediaRecorder.ondataavailable = (event) => {
        setRecordedChunks((prev) => [...prev, event.data]);
      };

      mediaRecorder.onstop = () => {
        const newBlob = new Blob(recordedChunks, { type: "audio/mp3" });
        if (blob) {
          const blobs = [blob, newBlob];
          const concatenatedBlob = new Blob(blobs, { type: "audio/mp3" });
          
          var reader = new FileReader();
          reader.readAsDataURL(concatenatedBlob);
          reader.onloadend = function () {
            var base64String = reader.result;
            localStorage.setItem("usersAudio", base64String);
          };

          setBlob(concatenatedBlob);
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(newBlob);
          reader.onloadend = function () {
            var base64String = reader.result;
            localStorage.setItem("usersAudio", base64String);
          };
          setBlob(newBlob);
        }
        setIsRecording(false);
      };
    }
  }, [mediaRecorder, recordedChunks, blob]);

  const handleConvertBlob = async (Base64) =>{
    
    if(Base64){
      const base64Response = await fetch(Base64);
      const blobFile = await base64Response.blob();
      return blobFile
    }
    return null
    
  }

  useEffect(async() => {
    if (initialBase64) {
        const oldblob = await handleConvertBlob(initialBase64)
        console.log("OLDBLOB",oldblob);
        setBlob(oldblob)
    }
  }, [initialBase64]);


  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    setMediaRecorder(recorder);
    recorder.start();
    setIsRecording(true);
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      setTimeout(() => {
        mediaRecorder.stop();
        mediaRecorder.stream.getTracks().forEach((track) => track.stop());
      }, 1000);
    }
  };

  const buttonStyle = {
    padding: "10px 20px",
    margin: "10px",
    borderRadius: "5px",
    border: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  };

  const recordingStatusStyle = {
    textAlign: "center",
    fontSize: "24px",
    margin: "20px 0",
  };

  const audioPlayerStyle = {
    display: "block",
    margin: "20px auto",
    width: "100%",
    maxWidth: "500px",
  };

  return (
    <div>
      <div style={recordingStatusStyle}>
        {isRecording ? "Recording..." : "Not Recording"}
      </div>
      {blob && (
        <audio
          style={audioPlayerStyle}
          controls
          src={URL.createObjectURL(blob)}
        >
          Your browser does not support the audio element.
        </audio>
      )}
      <div>
        <button style={buttonStyle} onClick={startRecording}>
          Start Recording
        </button>
        <button style={buttonStyle} onClick={stopRecording}>
          Stop Recording
        </button>
      </div>
    </div>
  );
};

export default AudioRecorder;
